import { createSelector } from 'reselect';

import { RequestState } from '../reducers/utils/state-manager';

export type HrisIntegrationTypeState = {
  hrisIntegrationTypes: HrisIntegrationType[];
  hrisIntegrationTypesState: RequestState;
};

type State = {
  hrisIntegrationTypes: HrisIntegrationTypeState;
};

const hrisIntegrationTypesSelector = (state: State) =>
  state.hrisIntegrationTypes.hrisIntegrationTypes;

export const allHrisIntegrationTypesSelector = createSelector(
  [hrisIntegrationTypesSelector],
  (hrisIntegrationTypes) => hrisIntegrationTypes,
);

const hrisIntegrationTypesStateSelector = (state: State) =>
  state.hrisIntegrationTypes.hrisIntegrationTypesState;

export const allHrisIntegrationTypesStateSelector = createSelector(
  [hrisIntegrationTypesStateSelector],
  (hrisIntegrationTypesState) => hrisIntegrationTypesState,
);
